export const validation = (values) => {
  const errors = {};
  if (values.appointmentType === 'another' && !values.appointmentTypeId ) {
    errors.appointmentTypeId = 'required';
  }
  if (values.schedule === 'another' && !values.scheduleId ) {
    errors.scheduleId = 'required';
  }
  if (values.daysOfWeekType === 'newByUser' && !values.days.length) {
    errors.days = ' ';
  }
  return errors;
};